import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum MessageType {
    DataSet,
    Refresh,
    HttpError,
    EntryToEdit,
    InitCompleted
}

/**
 * Message exchange support
 * @author amchavan
 */

@Injectable()
export class MessageExchange {

    // Note the 'shorthand' notation: in ES6, you can/should use {errorDescription}
    // instead of {errorDescription: errorDescription}

    private static readonly MESSAGE_BUS = new Subject<any>();

    public broadcastHttpErrorMessage( serverName: any, errorInfo: any, errorDescription: any ) {
        MessageExchange.MESSAGE_BUS.next( { type: MessageType.HttpError, serverName, errorInfo, errorDescription } );
    }

    public broadcastInitCompleted() {
        MessageExchange.MESSAGE_BUS.next( { type: MessageType.InitCompleted } );
    }

    public getMessageExchange(): Observable<any> {
        return MessageExchange.MESSAGE_BUS.asObservable();
    }
}
